<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>偷基础倍率</span>
          <el-row :gutter="10" class="mb8" style="margin-top: 20px;">
            <el-col :span="1.5">
              <el-upload
                ref="upload"
                class="upload-demo"
                :action="sys_app_logoAction"
                accept="xlsx"
                :limit="1"
                :on-success="(res)=>{return importProbUploadSuccess(res)}"
                :headers="headers"
              >
                <el-button v-permisaction="['config:steal-ratio:import']" :loading="loading" icon="el-icon-upload2" size="mini" type="primary">导入</el-button>
              </el-upload>
            </el-col>

            <el-col :span="1.5">
              <el-button
                v-permisaction="['config:steal-ratio:export']"
                type="primary"
                icon="el-icon-download"
                size="mini"
                @click="exportData()"
              >导出</el-button>
            </el-col>
          </el-row>
        </div>

        <el-form :inline="true" class="demo-form-inline">
          <el-row v-for="(item, index) in formData" :key="index">
            <el-form-item label="等级">
              <el-input v-model.number="item.levelId" style="width: 100px;" placeholder="等级" />
            </el-form-item>
            <el-form-item label="基础倍率">
              <el-input v-model.number="item.v" style="width: 100px;" placeholder="基础倍率" />
            </el-form-item>
            <el-form-item label="好友权重">
              <el-input v-model.number="item.friend_v" style="width: 100px;" placeholder="好友权重" />
            </el-form-item>
            <el-form-item label="非好友权重">
              <el-input v-model.number="item.not_friend_v" style="width: 100px;" placeholder="非好友权重" />
            </el-form-item>
            <el-form-item label="机器人倍率">
              <el-input v-model.number="item.robot_v" style="width: 100px;" placeholder="机器人倍率" />
            </el-form-item>
            <el-form-item>
              <el-button v-permisaction="['config:steal-ratio:del']" type="danger" @click="del(item.levelId)">删除</el-button>
            </el-form-item>
          </el-row>
          <el-form-item>
            <el-button v-permisaction="['config:steal-ratio:add']" type="primary" @click="add()">+</el-button>
          </el-form-item>
          <el-button v-permisaction="['config:steal-ratio:add']" type="primary" @click="onSubmit()">保存</el-button>
        </el-form>

        <pagination
          v-show="total>0"
          background
          :page.sync="queryParams.pageIndex"
          :limit.sync="queryParams.pageSize"
          :total="total"
          @pagination="getTables"
        />
      </el-card>

    </template>
  </BasicLayout>
</template>

<script>
import {
  delStealRatio,
  exportStealRatio,
  getStealRatioList,
  importStealRatio,
  updateStealRatio
} from '@/api/config/steal-ratio'
import { getToken } from '@/utils/auth'
export default {
  name: 'StealRatio',
  data() {
    return {
      headers: { 'Authorization': 'Bearer ' + getToken() },
      sys_app_logoAction: process.env.VUE_APP_BASE_API + '/api/v1/public/uploadFile',
      total: 0,
      queryParams: {
        pageIndex: 1,
        pageSize: 10
      },
      formData: [
        {
          'levelId': 1,
          'v': 0,
          'friend_v': 0,
          'not_friend_v': 0,
          'robot_v': 0
        }
      ]
    }
  },
  created() {
    this.getTables()
  },
  methods: {
    onSubmit() {
      const data = JSON.stringify(this.formData)
      console.log(data)
      updateStealRatio({ data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      getStealRatioList().then(res => {
        this.formData = res.data
      })
    },
    add() {
      const id = this.formData.length
      this.formData.push({
        'levelId': id + 1,
        'v': 0,
        'friend_v': 0,
        'not_friend_v': 0,
        'robot_v': 0
      })
    },
    del(id) {
      console.log('delete', id)
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delStealRatio({ id: id }).then(res => {
          if (res.code === 200) {
            this.msgSuccess(res.msg)
            this.getTables()
          } else {
            this.msgError(res.msg)
          }
        })
      })
    },
    exportData() {
      exportStealRatio().then(res => {
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    importProbUploadSuccess(response) {
      this.loading = true
      this.$refs.upload.clearFiles()
      importStealRatio({ data: response.data.path }).then(res => {
        this.loading = false
        // eslint-disable-next-line eqeqeq
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
